import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';
// SHARED
import { removeMember } from '../enterprise/members/actions.js'

const btnInlineStyle =   {
    width: "100%",
    height: "45px",
    fontSize: "18px"
}
const fullWidth = {
    width: "100% ",
    textAlign: "center",
    fontSize: "18px"
}

const ConfirmRemoveModal = ({ member, dispatch }) => (
  <div className="subscription-form-box">
    <Modal bsSize="small" show={true} onHide={() => dispatch({type:'HIDE_MODAL_2'})} dialogClassName="custom-modal" >
      <Modal.Header closeButton>
        <Modal.Title>Remove {member.email}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={ 12 } sm={ 12 }>
            <FormGroup controlId="alert-modal-body">
              <div className="full-width-center-text" style={fullWidth}>
                 <p>You sure you want to remove {member.email} from your enterprise group?</p>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <div className="full-width-center-text" style={fullWidth}>
            <Button className="btn-main-green" style={btnInlineStyle} type="submit" onClick={() => {
              dispatch(removeMember(member.token_id))
              // TODO replace both with dispatch(hideModal()) and move to actions
              // TODO make it a promise?
              // .then(() => {
              //   dispatch({type:'HIDE_MODAL_2'})
              // })
              dispatch({type:'HIDE_MODAL_2'})

            }}>
              Yes
            </Button>
            <Button className="btn btn-link" onClick={() => dispatch({type:'HIDE_MODAL_2'})}>
              Cancel
            </Button>
          </div>
        </Row>

      </Modal.Body>
    </Modal>

  </div>
)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({
    member: state.enterprise.members.members.filter(m=>m.token_id==ownProps.tokenId)[0]
  })
)(ConfirmRemoveModal)



// WEBPACK FOOTER //
// ./src/modal/ConfirmRemoveModal.js